"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.http = void 0;
var http = {
  get: function get(url) {
    return fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      referrerPolicy: 'no-referrer',
      credentials: 'include',
      redirect: 'follow'
    }).then(function (response) {
      if (response.status !== 200) {
        throw new Error(JSON.stringify(response.json()));
      } else {
        return response.json();
      }
    });
  },
  post: function post(url) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      referrerPolicy: 'no-referrer',
      credentials: 'include',
      redirect: 'follow',
      body: JSON.stringify(data)
    }).then(function (response) {
      if (response.status !== 200) {
        throw new Error(JSON.stringify(response.json()));
      } else {
        return response.json();
      }
    });
  },
  delete: function _delete(url) {
    return fetch(url, {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      referrerPolicy: 'no-referrer',
      credentials: 'include',
      redirect: 'follow'
    }).then(function (response) {
      if (response.status !== 200) {
        throw new Error(JSON.stringify(response.json()));
      } else {
        return Boolean(response.text());
      }
    });
  }
};
exports.http = http;